<template lang="pug">
  #app
    router-view
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
:root {
  --color-primary: #2563eb;
  --color-primary-dark: #1d4ed8;
  --color-accent: #10b981;
  --color-background: #f3f6fb;
  --color-surface: #ffffff;
  --color-surface-soft: #f8fafc;
  --color-text: #172033;
  --color-muted: #64748b;
  --color-border: #dce3ed;
  --color-danger: #dc2626;
  --color-warning: #d97706;
  --color-success: #047857;
  --color-sidebar: #0f172a;
  --shadow-sm: 0 1px 2px rgba(15, 23, 42, 0.06);
  --shadow-md: 0 12px 28px rgba(15, 23, 42, 0.1);
  --radius-sm: 8px;
  --radius-md: 12px;
  --motion-fast: 160ms ease;
}

* {
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100%;
  min-width: 320px;
  height: 100%;
  margin: 0;
}

body {
  overflow: hidden;
  background: var(--color-background);
  color: var(--color-text);
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

button,
input,
select,
textarea {
  font: inherit;
}

a {
  color: var(--color-primary);
  text-decoration: none;
}

a:hover {
  color: var(--color-primary-dark);
  text-decoration: underline;
}

.skip-link {
  position: fixed;
  z-index: 2000;
  top: 8px;
  left: 8px;
  padding: 10px 14px;
  border-radius: var(--radius-sm);
  background: var(--color-surface);
  color: var(--color-text);
  box-shadow: var(--shadow-md);
  transform: translateY(-150%);
  transition: transform var(--motion-fast);
}

.skip-link:focus {
  transform: translateY(0);
}

.module__main {
  display: flex;
  min-width: 0;
  min-height: 0;
  height: 100%;
  flex-direction: column;
}

.module-content__container {
  display: flex;
  min-width: 0;
  min-height: 0;
  height: 100%;
  flex: 1;
  flex-direction: column;
  padding: 16px;
  overflow: hidden;
}

.filters__container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  box-shadow: var(--shadow-sm);
}

.filter-options__container,
.dates__container,
.search__container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-options__container {
  flex-wrap: wrap;
}

.dates__container {
  min-width: 0;
}

.date__container {
  display: flex;
  min-width: 0;
  align-items: center;
}

.search__container {
  min-width: 340px;
  margin-left: auto;
}

.search__container .el-select {
  width: 210px;
  flex: 0 0 auto;
}

.search__container .el-input {
  min-width: 180px;
}

.search-reset__btn {
  flex: 0 0 auto;
}

.control-buttons__container {
  display: flex;
  margin-bottom: 12px;
}

.module-content__container > .el-alert {
  margin-bottom: 12px;
}

.table__container {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex: 1;
  flex-direction: column;
}

.table-list__container {
  min-width: 0;
  min-height: 0;
  flex: 1;
  overflow: auto;
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-surface);
  box-shadow: var(--shadow-sm);
}

.table-list__container .el-table {
  color: var(--color-text);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.table-list__container .el-table th {
  background: var(--color-surface-soft);
  color: #46546a;
  font-weight: 700;
}

.table-list__container .el-table th > .cell {
  white-space: nowrap;
}

.table-list__container .el-table td,
.table-list__container .el-table th.is-leaf {
  border-bottom-color: #e8edf4;
}

.table-list__container .el-table .cell {
  line-height: 1.45;
}

.table-list__container .el-table--border::after,
.table-list__container .el-table--group::after,
.table-list__container .el-table::before {
  background-color: var(--color-border);
}

.table-pagination__container {
  min-height: 44px;
  padding-top: 12px;
  text-align: center;
}

.table-pagination__container .el-pagination {
  margin-top: 0 !important;
}

.table-list__container .val,
.address__container,
.wallet-address_text {
  overflow-wrap: anywhere;
}

.address__container,
.token__val,
.aml-report-details__break,
.el-table .mono-cell {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
}

.address__container {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  color: #334155;
  cursor: pointer;
}

.address__container:hover {
  color: var(--color-primary-dark);
}

.wallet-amount,
.available-amount,
.aml-score,
.aml-history__score,
.balance__block {
  font-variant-numeric: tabular-nums;
}

.address__container[role="button"]:focus-visible,
.user-active-change__btn:focus-visible,
.add-ip__btn:focus-visible,
.menu-width-handler__container:focus-visible {
  outline: 3px solid rgba(37, 99, 235, 0.35);
  outline-offset: 2px;
}

.dialog__container {
  padding: 0 2px;
}

.dialog-input__container,
.dialog-input__cointaner {
  margin-bottom: 14px;
}

.dialog-input__container .title,
.dialog-input__cointaner .title {
  margin-bottom: 6px;
  color: #46546a;
  font-size: 13px;
  font-weight: 600;
}

.dialog__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid var(--color-border);
}

.dialog__buttons .el-button + .el-button {
  margin-left: 0;
}

.el-card,
.el-dialog,
.el-message-box {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
}

.el-dialog {
  max-width: 720px;
}

.el-dialog__header {
  padding: 20px 24px 14px;
  border-bottom: 1px solid var(--color-border);
}

.el-dialog__body {
  padding: 20px 24px 24px;
}

.el-button,
.el-input__inner,
.el-textarea__inner,
.el-date-editor,
.el-input-number {
  border-radius: var(--radius-sm);
}

.el-button {
  font-weight: 600;
  transition: color var(--motion-fast), border-color var(--motion-fast), background-color var(--motion-fast), box-shadow var(--motion-fast), transform var(--motion-fast);
}

.el-button:not(.is-disabled):active {
  transform: translateY(1px);
}

.el-button--primary {
  border-color: var(--color-primary);
  background: var(--color-primary);
}

.el-button--primary:focus,
.el-button--primary:hover {
  border-color: var(--color-primary-dark);
  background: var(--color-primary-dark);
}

.el-input__inner:focus,
.el-textarea__inner:focus,
.el-select .el-input.is-focus .el-input__inner {
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: var(--color-primary);
  background-color: var(--color-primary);
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--color-primary-dark);
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: var(--color-primary);
}

.el-alert {
  border-radius: var(--radius-sm);
}

.color-success { color: var(--color-success); }
.background-success { background-color: var(--color-success); }
.color-warning { color: var(--color-warning); }
.background-warning { background-color: var(--color-warning); }
.color-danger { color: var(--color-danger); }
.background-danger { background-color: var(--color-danger); }
.color-info { color: var(--color-muted); }
.background-info { background-color: var(--color-muted); }
.color-primary { color: var(--color-primary); }
.background-primary { background-color: var(--color-primary); }
.title { font-weight: 600; }
.mr5 { margin-right: 5px; }
.ml5 { margin-left: 5px; }
.mt5 { margin-top: 5px; }
.mb5 { margin-bottom: 5px; }
.mr10 { margin-right: 10px; }
.ml10 { margin-left: 10px; }
.mt10 { margin-top: 10px; }
.mb10 { margin-bottom: 10px; }
.hidden { display: none; }
.cursor-pointer { cursor: pointer; }

@media (max-width: 1024px) {
  .module-content__container {
    padding: 12px;
  }

  .filters__container > *,
  .search__container {
    width: 100%;
  }

  .search__container {
    min-width: 0;
    margin-left: 0;
  }

  .search__container .el-input {
    flex: 1 1 220px;
  }

  .el-dialog {
    width: 92vw !important;
  }
}

@media (max-width: 640px) {
  .module-content__container {
    padding: 8px;
  }

  .filters__container {
    padding: 8px;
  }

  .dates__container,
  .date__container,
  .date__container .el-date-editor,
  .search__container .el-select,
  .search__container .el-input {
    width: 100%;
  }

  .dates__container,
  .search__container {
    flex-wrap: wrap;
  }

  .dialog__buttons .el-button {
    min-height: 40px;
    flex: 1 1 120px;
  }

  .el-dialog__header {
    padding: 16px 18px 12px;
  }

  .el-dialog__body {
    padding: 16px 18px 20px;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
  }
}
</style>
